/**
 * Function to format image name to do prettier url
 * @param {string} name The name of the image
 * @param {boolean} reverse Define if the image will be formatted back to original format.
 */
export default function formatImageName(name, reverse) {
  if (reverse) {
    return name.split('-').join('_');
  }

  return name.split('_').join('-');
}
